module.exports = __webpack_public_path__ + "img/stairs.18dab1b4.svg";